require('./cardChargeStep2.scss');

const PropTypes = require('prop-types');

//@ Vendor
const React = require('react');
//@ Helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { getLastNChars, nonNumericFilter } = require('utilities/stringHelper');
const { getFormattedString } = require('utilities/currencyHelper');
const { getCardAvailableBalance } = require('utilities/cardsHelper');
const dateHelper = require('utilities/dateHelper');
//@ Components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ Constants
const {
    CARD_CHARGE_OPERATION_CHARGE,
    CARD_CHARGE_OPERATION_DISCHARGE,
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    FIRST_STEP,
    PERIODICITY_COUNT,
    PERIODICITY_DATE,
    DATE_FORMAT_ES,
    DATE_FORMAT_EN,
    PERIODICITY_CONSTANTLY,
    MONEY_REQUEST_VIEW,
    SAVINGS_REQUEST_VIEW
} = require('constants/index');
const { ECARD_CHARGE_ID, ECARD_DISCHARGE_ID } = require('constants/operationTypes');
//@commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

class CardChargeStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.buildInformativeSection = this.buildInformativeSection.bind(this);
        this.buildListItems = this.buildListItems.bind(this);
    }

    buildPeriodicityLimit() {
        const firstStep = this.props.immCardCharge.getIn(['steps', 0]);
        const dateFormat = getLanguage() === 'es' ? DATE_FORMAT_ES : DATE_FORMAT_EN;
        let text;

        if (firstStep.get('periodicityEnabled')) {
            const periodicityType = firstStep.get('periodicityType');

            switch (periodicityType) {
                case PERIODICITY_COUNT:
                    const count = firstStep.get('periodicityCount') + 1;
                    const translationText =
                        count === 1
                            ? 'step2InfoMsgRepetitionsCountSingular'
                            : 'step2InfoMsgRepetitionsCount';
                    text = formatText(`transferSummary-${translationText}`, [count]);
                    break;
                case PERIODICITY_DATE:
                    const dateHumanReadable = dateHelper.buildFormattedDate(
                        firstStep.get('periodicityDate'),
                        dateFormat
                    );
                    text = formatText('transferSummary-step2RepeatUntil', [dateHumanReadable]);
                    break;
                case PERIODICITY_CONSTANTLY:
                    text = formatText('periodicity-constantly');
                    break;
            }
        }

        return text
            ? <p className="periodicity-type">
                {' '}{text}{' '}
            </p>
            : false;
    }

    buildPeriodicityText() {
        const firstStep = this.props.immCardCharge.getIn(['steps', 0]);
        const rangeType = firstStep.get('periodicityRange').toLowerCase();
        const rangeTypeHumanReadable = formatText(`periodicity-${rangeType}`);

        return rangeTypeHumanReadable;
    }

    buildListItems(list) {
        const periodicityLimit = this.buildPeriodicityLimit();
        const modifiedList = list.map((data, index) => {
            const extraClassName = data.title.replace(/\s/g, '-');
            const operation = this.props.immCardCharge.getIn(['steps', '0', 'operationType']);
            let innerContent;
            if(index === 3 && operation === CARD_CHARGE_OPERATION_CHARGE) {
                innerContent = periodicityLimit;
            }
            if(data.key) {
                return(
                    <OKInformativeListItem
                        bodyText={data.key}
                        bodyWordBreak={false}
                        key={index}
                        title={data.title}
                        className={`list-item-${extraClassName}`}
                    >
                        {innerContent}
                    </OKInformativeListItem>
                );
            }
        });
        return modifiedList;
    }

    buildInformativeSection() {
        const { immCard, immAccounts, immCardCharge, view } = this.props;
        const immFirstStep = immCardCharge.getIn(['steps', FIRST_STEP]);
        const accountId = immFirstStep.get('accountId');
        const periodicityConcept = immFirstStep.get('periodicityConcept');
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const operation = immCardCharge.getIn(['steps', '0', 'operationType']);
        const operationMessage = this.buildOperationMessage();
        const operativeName= formatText('operatives-chargeEcard');

        //build alias with IBAN
        const accountAlias = immAccount.get('alias');
        const iban = immAccount.get('iban');
        const formattedIBAN = getLastNChars(iban);
        const accountAliasIban = `${accountAlias} ${formattedIBAN}`;

        const currentBalance = getCardAvailableBalance(immCard);
        let newAvailableBalance = 0;

        const formattedImport = this.buildValueWithCurrency(immFirstStep.get('amount'));
        const formattedCurrentBalance = this.buildValueWithCurrency(currentBalance.amount);
        const immCardChargeStep1 = immCardCharge.getIn(['steps', '0']);
        const periodicityEnabled = immCardChargeStep1.get('periodicityEnabled');
        let hasRepetitions;
        const accountTitle = (view === SAVINGS_REQUEST_VIEW) ? 'moneySavingsRequest-accountsStep2Label' : 'cardCharge-accounts';
        let list;

        if (operation === CARD_CHARGE_OPERATION_CHARGE) {
            newAvailableBalance = currentBalance.amount + immFirstStep.get('amount');
            hasRepetitions = periodicityEnabled
                ? this.buildPeriodicityText()
                : formatText('transferSummary-step2NoRepetitions');
        } else {
            newAvailableBalance = currentBalance.amount - immFirstStep.get('amount');
        }
        const formattedNewBalance = this.buildValueWithCurrency(newAvailableBalance);

        const startDateValue = dateHelper.buildFormattedDate(
            immCardChargeStep1.get('date'),
            DATE_FORMAT_ES
        );

        list = [
            {
                key: accountAliasIban,
                title: formatText(accountTitle)
            },
            {
                key: formattedImport,
                title: formatText('cardCharge-amount')
            },
        ];

        if(operation === CARD_CHARGE_OPERATION_CHARGE && periodicityEnabled) {
            list.push(
              {
                key: startDateValue,
                title: formatText('cardCharge-startDate')
              },
              {
                key: hasRepetitions,
                title: formatText('transferSummary-step2Periodicity')
              },
              {
                key: periodicityConcept,
                title: formatText('cardCharge-concept')
              }
            );
        } else if(view !== MONEY_REQUEST_VIEW && view !== SAVINGS_REQUEST_VIEW) {
            list.push({
                    key: formattedCurrentBalance,
                    title: formatText('cardCharge-balance')
                },{
                key: formattedNewBalance,
                title: formatText('cardCharge-newBalance')
            });
        }
        return (
            <section>
                <ContactCenterRender>
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        operative={operativeName}
                    />
                </ContactCenterRender>
                {operationMessage}
                <OKInformativeList columns={2}>
                    {this.buildListItems(list)}
                </OKInformativeList>
            </section>
        );
    }

    buildOperationMessage() {
        const { view } = this.props;
        let operationMessage;

        if(view === SAVINGS_REQUEST_VIEW) {
            operationMessage = (
                <div className="card-charge-step-two__message">
                    <FormattedText value="moneySavingsRequest-confirmationText" className="card-charge-step-two__message" />
                </div>
            )
        } else {
            const operationType = this.props.immCardCharge.getIn([
                'steps',
                FIRST_STEP,
                'operationType'
            ]);
            let operationTypeKey =
                operationType === CARD_CHARGE_OPERATION_DISCHARGE ? 'discharge' : 'charge';

            operationMessage = (
                <div className="card-charge-step-two__message">
                    <FormattedText value="cardCharge-secondStepMessagePart1" />
                    <FormattedText
                        value={`cardCharge-${operationTypeKey}`}
                        format="lowercase"
                        className="card-charge-step-two__message-operation"
                    />
                    <FormattedText value="cardCharge-secondStepMessagePart2" />
                </div>
            );
        }
        return operationMessage;
    }

    buildSignatureSection() {
        const { immCard, immCardCharge, immAccounts } = this.props;

        const operation = immCardCharge.getIn(['steps', '0', 'operationType']);
        const operationType =
            operation === CARD_CHARGE_OPERATION_CHARGE ? ECARD_CHARGE_ID : ECARD_DISCHARGE_ID;

        const accountId = immCardCharge.getIn(['steps', '0', 'accountId']);
        const contractNumber = immAccounts.getIn(['byId', accountId, 'contractNumber']);
        const product = immAccounts.getIn(['byId', accountId, 'product']);
        const account = API_ENTERPRISE_NUMBER + API_CENTER + product + contractNumber;

        const operationParams = {
            pan: nonNumericFilter(immCard.get('number')),
            ammount: immCardCharge.getIn(['steps', 0, 'amount']),
            currency: immCard.getIn(['availableBalance', 'currency'])
        };
        if (operation === CARD_CHARGE_OPERATION_CHARGE) {
            operationParams.originAccount = account;
        } else {
            operationParams.destinationAccount = account;
        }

        return (
            <section className="card-charge-step-two__content">
                <SignaturePattern operationType={operationType} operationParams={operationParams} />
            </section>
        );
    }

    buildValueWithCurrency(amount) {
        const { immCard } = this.props;
        const currency = immCard.getIn(['extra', 'eCardInfo', 'saldoActualPrepago', 'divisa']);

        const amountObject = { amount, currency };

        return getFormattedString(amountObject);
    }

    render() {
        const signatureSection = this.buildSignatureSection();
        const informativeSection = this.buildInformativeSection();

        return (
            <article className="card-charge-step-two">
                <header className="card-charge-step-two__header">
                    <FormattedText
                        value="cardCharge-securityConfirmation"
                        className="card-charge-step-two__title"
                    />
                </header>
                {informativeSection}
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}/>
                </ContactCenterRender>
                {signatureSection}
            </article>
        );
    }
}

CardChargeStep2.propTypes = {
    immCardCharge: PropTypes.object,
    immCard: PropTypes.object,
    immAccounts: PropTypes.object,
    view: PropTypes.string
};

module.exports = CardChargeStep2;
